export default "__VITE_ASSET__CewlFQQi__"